export default __webpack_public_path__ + "static/img20-ca975d9a9cceed91e4d1202b8f0750b6.jpg";